<template>
  <div>
    <h5 class="card-title">
      <i class="fas fa-calendar-times"></i>
      Solicitações LGPD Atrasadas
    </h5>

    <div v-if="loading" class="text-center">
      <b-spinner small></b-spinner>
      <span class="ml-2">Carregando...</span>
    </div>
    <div v-else-if="allDsars.length === 0" class="text-muted text-center">
      <i class="fas fa-check-circle"></i>
      Nenhuma solicitação atrasada encontrada
    </div>
    <div v-else>
      <div class="mb-3">
        <div>
          <b-badge variant="danger" class="mr-2">
            Total: {{ totalOverdue }}
          </b-badge>
          <small class="text-muted">solicitações LGPD com prazo expirado</small>
        </div>
      </div>

      <div class="list-container">
        <div class="list-header">
          <div class="row-content">
            <div class="protocol-section header-label">Protocolo</div>
            <div class="company-section header-label">Empresa</div>
            <div class="days-section header-label">Dias Atraso</div>
            <div class="date-section header-label">Prazo Final</div>
            <div class="actions-section header-label">Ação</div>
          </div>
        </div>
        <div class="list-scroll">
          <div
            v-for="dsar in allDsars"
            :key="dsar._id"
            class="list-row"
            @click="viewDsar(dsar)"
          >
            <div class="row-content">
              <div class="protocol-section">
                <b-badge variant="secondary">{{ dsar.protocol }}</b-badge>
              </div>
              <div class="company-section">
                {{ dsar.companyName }}
              </div>
              <div class="days-section">
                <b-badge variant="danger"
                  >{{ Math.floor(dsar.daysOverdue) }} dias</b-badge
                >
              </div>
              <div class="date-section">
                {{ dsar.deadline | date }}
              </div>
              <div class="actions-section">
                <b-button size="sm" variant="primary">Ver</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOverdueDsar } from "../../../../api/charts";

export default {
  name: "OverdueDsar",
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      data: [],
      loading: true,
    };
  },
  computed: {
    allDsars() {
      const list = [];
      this.data.forEach((company) => {
        company.dsars.forEach((item) => {
          list.push({
            ...item,
            companyName: company._id.fantasyName || company._id.name,
          });
        });
      });
      return list.sort((a, b) => b.daysOverdue - a.daysOverdue);
    },
    totalOverdue() {
      return this.allDsars.length;
    },
  },
  watch: {
    companyId() {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const response = await getOverdueDsar(this.companyId);
        this.data = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar solicitações atrasadas:", error);
      } finally {
        this.loading = false;
      }
    },
    viewDsar(item) {
      this.$router.push(`/lgpd/${item._id}`);
    },
  },
};
</script>

<style scoped>
.list-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.list-header {
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.header-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.list-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.list-row {
  border-bottom: 1px solid #f1f3f4;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.list-row:hover {
  background-color: #f8f9fa;
}

.list-row:last-child {
  border-bottom: none;
}

.row-content {
  display: grid;
  grid-template-columns: 1.5fr 2fr 1fr 1.5fr 0.8fr;
  align-items: center;
  gap: 1rem;
}

.protocol-section,
.company-section,
.days-section,
.date-section,
.actions-section {
  display: flex;
  align-items: center;
}

.company-section {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-title .fas {
  margin-right: 8px;
  color: #dc3545;
}
</style>
